import join from 'url-join';
import Cookie from 'js-cookie';
import type { ChangeEvent } from 'react';
import { OptimizelyDecideOption as Options } from '@optimizely/optimizely-sdk';
import { useOptimizely } from '@libs/common-next';
import { useOverrides } from '../../store';
import type { Flag } from '../../types';

export function useFlag(flag: Flag) {
    const { context, instance } = useOptimizely();
    const { overrides, setOverride } = useOverrides();

    return {
        value:
            overrides[flag.key] ??
            (context?.decide(flag.key, [Options.DISABLE_DECISION_EVENT])
                ?.variables.value as string),
        onChange(e: ChangeEvent<HTMLSelectElement>) {
            const value = { ...overrides, [flag.key]: e.target.value };

            Cookie.set('x-petm-override', JSON.stringify(value));
            setOverride(value);
        },
        isOverride: Object.keys(overrides).includes(flag.key),
        link: join(
            'https://app.optimizely.com/v2/projects',
            `${instance?.getProjectConfig()?.projectId}`,
            '/flags/manage',
            flag.key,
            '/variations'
        ),
    };
}
